import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = 'https://ufc-backend-nmib.onrender.com/api';

export default function PredictionExplanation({ fighter1, fighter2 }) {
  const [text,    setText]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    if (!fighter1?.fighter_id || !fighter2?.fighter_id) return;
    setLoading(true);
    setText(null);
    setError(null);

    axios.get(`${API}/matchup/explain`, {
      params: { f1: fighter1.fighter_id, f2: fighter2.fighter_id }
    })
      .then(res => setText(res.data.explanation))
      .catch(() => setError('Breakdown unavailable.'))
      .finally(() => setLoading(false));
  }, [fighter1?.fighter_id, fighter2?.fighter_id]);

  const f1Last = fighter1?.full_name?.split(' ').pop() || 'F1';
  const f2Last = fighter2?.full_name?.split(' ').pop() || 'F2';

  return (
    <div className="card tale-card">

      {/* Header */}
      <div className="tale-header">
        <div className="tale-fighter tale-fighter-f1">{f1Last}</div>
        <div className="tale-title-block">
          <div className="tale-eyebrow">Tale of the Tape</div>
          <div className="tale-ai-badge">AI Breakdown</div>
        </div>
        <div className="tale-fighter tale-fighter-f2">{f2Last}</div>
      </div>

      <div className="tale-divider" />

      {/* Body */}
      <div className="tale-body">
        {loading && (
          <div className="tale-loading">
            <span className="tale-dot" />
            <span className="tale-dot" />
            <span className="tale-dot" />
            <span className="tale-loading-text">Generating analyst breakdown…</span>
          </div>
        )}

        {error && (
          <p className="tale-error">{error}</p>
        )}

        {text && (
          <div className="tale-text">
            {text.split('\n\n').filter(Boolean).map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        )}
      </div>

    </div>
  );
}
